import { render, staticRenderFns } from "./ListCarousel.vue?vue&type=template&id=1ae952a6&scoped=true&"
import script from "./ListCarousel.vue?vue&type=script&lang=js&"
export * from "./ListCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ListCarousel.vue?vue&type=style&index=0&id=1ae952a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae952a6",
  null
  
)

export default component.exports